import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from 'src/app/modules/core/services/http.service';
import { Organization } from '../models/organization.model';
import { UserOrganization, UserProfile } from './user-profile.model';

import { API_BASE_URL as apiBaseUrl } from '@app/core/constants/api-base-url';
@Injectable({ providedIn: 'root' })
export class UserProfileApiService {
  constructor(private http: HttpService) {}

  getUser(organizationUId: string, uId: string): Observable<UserProfile> {
    const url = `${apiBaseUrl}/v1/iam/organizations/${organizationUId}/user-profiles/${uId}/get-self`;

    return this.http.get(url);
  }

  updateUser(organizationUId: string, user: UserProfile): Observable<UserProfile> {
    const url = `${apiBaseUrl}/v1/iam/organizations/${organizationUId}/user-profiles/${user.uId}/self-service`;

    return this.http.put(url, user);
  }

  updatePassword(organizationUId: string, uId: string, password: string, newPassword: string) {
    const url = `${apiBaseUrl}/v1/iam/organizations/${organizationUId}/user-profiles/${uId}/self-service/password-update`;

    return this.http.post(url, { password, newPassword });
  }

  getUserOrganizations(organizationUId: string, userProfileUId: string): Observable<UserOrganization[]> {
    const url = `${apiBaseUrl}/v1/iam/organizations/${organizationUId}/user-profiles/${userProfileUId}/organizations`;

    return this.http.get(url);
  }

  getUserOrganization(organizationUId: string): Observable<Organization> {
    const url = `${apiBaseUrl}/v1/iam/organizations/${organizationUId}/get-self`;

    return this.http.get(url);
  }

  getUsersForMention(organizationUId: string, searchText: string) {
    const url = `${apiBaseUrl}/v1/iam/organizations/${organizationUId}/user-profile-mentions/search?searchText=${encodeURIComponent(
      searchText
    )}`;
    return this.http.get(url);
  }

  getMyIpAddress(organizationUId: string, userProfileUId: string): Observable<{ ipAddress: string }> {
    const url = `${apiBaseUrl}/v1/iam/organizations/${organizationUId}/user-profiles/${userProfileUId}/my-ip-address`;
    return this.http.get(url);
  }
}
